import { CSSVariablesResolver } from '@mantine/core';

export const resolver: CSSVariablesResolver = () => ({
  variables: {
    '--button-bg': 'var(--ds-accent-blue-500)',
    '--button-hover': 'var(--ds-accent-blue-700)',
    '--mantine-color-error': 'var(--ds-status-error)',
    '--tooltip-color': 'var(--ds-white)',
    '--tooltip-bg': 'var(--ds-accent-blue-500)',
  },
  light: {
    '--mantine-color-body': 'var(--ds-background)',
    '--mantine-color-text': 'var(--ds-font-color)',
    '--tabs-active-color': 'var(--ds-accent-blue-500)',
  },
  dark: {
    '--mantine-color-body': 'var(--ds-background)',
    '--mantine-color-text': 'var(--ds-font-color)',
    '--tabs-active-color': 'var(--ds-font-color)',
    '--tooltip-bg': 'var(--ds-grey-200)',
    '--tooltip-color': 'var(--ds-font-color)',
  },
});
